import "./style.scss";
import $ from 'jquery';

function elementScrolled(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
    var elemTop = $(elem).offset().top;
    return ((elemTop <= docViewBottom) && (elemTop >= docViewTop));
}

function animateCount(el, start) {
    start = start || 1;
    el.prop('Counter', start).animate({
        Counter: el.text()
    }, {
        duration: 1000,
        easing: 'swing',
        step: function (now) {
            el.text(dotSeparateNumber(Math.ceil(now)));
        }
    });
}

function dotSeparateNumber(val) {
    while (/(\d+)(\d{3})/.test(val.toString())) {
        val = val.toString().replace(/(\d+)(\d{3})/, '$1' + '.' + '$2');
    }
    return val;
}

let a = 0;
$(window).scroll(function () {
    if (a === 0 && elementScrolled(".numbers-roll-down")) {
        $('.numbers-roll-down__number').each(function () {
            animateCount($(this));
        });
        a = 1;
    }
});